import actions from './actions/actions'
import mutations from './mutations/mutation'
const state = {
  checkedSlide: false,
  codeisexsist: false,
  message: '',
  deleteFlag: false,
  codeinfo: {
    brandcode: '',
    serial: '',
    code: '',
    cardmedium: '',
    codetype: '',
    state: '',
    statename: '',
    cardkind: '',
    usenum: '',
    residuenum: '',
    selnum: '',
    selzones: '',
    defaultgoodscode: '',
    defaultgoodsname: '',
    optgoodsuid: '',
    cardprice: '',
    foperdate: '',
    actdate: '',
    startvaldate: '',
    endvaldate: '',
    flowcode: '',
    flowname: '',
    bbindflowsend: '',
    isbindstore: '',
    orderno: '',
    paystatus: '',
    paydate: '',
    isaddcardbag: '',
    upddate: ''
  },
  coupon: {
    code: '',
    coumedium: '',
    state: '',
    facevalue: '',
    minconamount: '',
    discount: '',
    defdate: '',
    startvaldate: '',
    endvaldate: '',
    upddate: '',
    orderno: '',
    usedfor: '',
    rulecode: '',
    scope: '',
    coupontype: '',
    sketch: '',
    owner: '',
    isaddcardbag: '',
    foperdatecode: ''
  },
  orderinfo: {
    orderno: '',
    porderno: '',
    ordstate: '',
    ordertype: '',
    goodstype: '',
    terminaltype: '',
    delimode: '',
    prosource: '',
    ncard: '',
    allamount: '',
    ordercontent: '',
    submitdate: '',
    buyermemo: '',
    evaorderstatus: '',
    bpromotion: '',
    igetstate: '',
    inum: '',
    interactivitystate: '',
    recvdate: '',
    deliverstartdate: '',
    deliverenddate: '',
    enddate: ''
  },
  actshow: false,
  receiverinfo: {
    receivername: '',
    fulladdr: '',
    receivertel: '',
    othtel: ''
  },
  flowinfo: {
    flowcode: '',
    flowname: '',
    mobile: '',
    tel: '',
    provincecode: '',
    province: '',
    citycode: '',
    city: '',
    districtcode: '',
    district: '',
    addrdet: '',
    mainpiclink: ''
  },
  cardsysbaseinfo: {
    brandcode: '',
    bshowcardprice: '',
    startday: '',
    endday: '',
    picklimit: '',
    supperdel: '',
    recvdatesetway: '',
    senddays: '',
    perintervals: '',
    cexpecttitle: '',
    cexpectmemo: ''
  },
  goodspiclist: [],
  optgoodsinfos: [],
  optgoods: {},
  checkErrorMessage: '',
  resultinfo: {},
  resulttype: '',
  resultinfoCode: [],
  selectedStoreinfo:{},
  codeList: {
    code: '',
    usenum: '',
    residuenum: '',
    selgoods: []
  },
  // 订单付款信息
  payorderinfo: {
    orderno: '',
    paystatus: '',
    actpayamount: '',
    ordercontent: '',
    recvdate: '',
    receivername: '',
    receivertel: '',
    othtel: '',
    fulladdr: '',
    submitdate: ''
  },
  // 订单号关联券卡剩余次数
  resnumlist: [],
  // 三级联动地址信息获取
  threeaddress: [],
  // 地址列表获取
  addresslist: [],
  // 订单号
  orderno: '',
  // 获取全国门店
  storeList: [],
  // 企业的订单和发货配置信息
  pubordprintinfo: {},
  // 登录者的会员编号
  membercode: '',
  // 多专区选择商品 重复商品遍历用
  goodList: [],
  // 请求输出出错时候用
  data: '',
  // 选中的信息
  optItems: '',
  // 期望发货日期用时间，开始、结束、不发货日期
  startdate: '',
  enddate: '',
  unsendtimestr: ''
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/store/modules/cardProject/cardProject.js